import axios from "axios";

export const getAnnexeCategories = (
  backOffice,
  uen,
  lng = "Fr",
  searchWord = "",
  enabled = null
) => {
  const requestUrl = `/data/annexe-category`;

  return axios.get(requestUrl, {
    params: {
      uen: uen,
      enabled: enabled,
      lng: lng.charAt(0).toUpperCase() + lng.slice(1),
      searchWord: searchWord,
      backOffice: backOffice
    }
  });
};

export const updateAnnexeCategoriesState = ({ uen, categories }) => {
  const requestUrl = `/data/annexe-category/update-state`;

  let formData = new FormData();
  formData.append("uen", uen);
  formData.append("categories", JSON.stringify(categories));

  return axios.post(requestUrl, formData);
};

export const updateAnnexeCategory = ({
  uen,
  id,
  labels,
  associatedAccount,
  type,
  backOffice
}) => {
  const requestUrl = `/data/annexe-category/update`;

  let formData = new FormData();
  formData.append("uen", uen);
  formData.append("id", id);
  formData.append("labelFr", labels.fr);
  formData.append("labelEn", labels.en);
  formData.append("labelNl", labels.nl);
  formData.append(
    "associatedAccount",
    associatedAccount ? associatedAccount : ""
  );
  formData.append("type", type);
  formData.append("backOffice", backOffice);

  return axios.post(requestUrl, formData);
};

export const deleteAnnexeCategory = ({ uen, id, backOffice }) => {
  const requestUrl = `/data/annexe-category/delete`;

  let formData = new FormData();
  formData.append("uen", uen);
  formData.append("id", id);
  formData.append("backOffice", backOffice);

  return axios.post(requestUrl, formData);
};

export const saveAnnexeCategory = ({
  uen,
  labels,
  associatedAccount,
  backOffice
}) => {
  const requestUrl = `/data/annexe-category/save`;

  let formData = new FormData();
  formData.append("uen", uen);
  formData.append("labelFr", labels.fr);
  formData.append("labelEn", labels.en);
  formData.append("labelNl", labels.nl);
  formData.append("backOffice", backOffice);
  formData.append(
    "associatedAccount",
    associatedAccount ? associatedAccount : ""
  );

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/annexeCategory.js